import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { TrendingUp } from "lucide-react";

import { TOOLTIP_STYLE } from "../components/Estados";

function Percentual({ titulo, pedidos, total, texto, corTexto, corBarra }) {
  const pct = total > 0 ? (pedidos / total) * 100 : 0;
  return (
    <div className="bg-muted/50 rounded-lg border p-4 flex flex-col justify-center">
      <h3 className="text-sm font-semibold mb-3">{titulo}</h3>
      <p className={`text-3xl font-bold ${corTexto}`}>{pct.toFixed(1).replace(".", ",")}%</p>
      <p className="text-xs text-muted-foreground mt-1">{texto}</p>
      <div className="w-full bg-muted rounded-full h-2.5 mt-3">
        <div className={`h-2.5 rounded-full transition-all ${corBarra}`} style={{ width: `${pct}%` }} />
      </div>
      <p className="text-xs text-muted-foreground mt-1">{pedidos} de {total}</p>
    </div>
  );
}

function ComboVsSimples({ simples, combo }) {
  const total = simples + combo;
  const dados = [{ name: "Simples", value: simples }, { name: "Combo", value: combo }];
  return (
    <div className="bg-muted/50 rounded-lg border p-4 flex flex-col items-center">
      <h3 className="text-sm font-semibold mb-2">Combo vs Simples</h3>
      {total > 0 ? (
        <>
          <ResponsiveContainer width="100%" height={140}>
            <PieChart>
              <Pie data={dados} cx="50%" cy="50%" innerRadius={30} outerRadius={55} dataKey="value" labelLine={false}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}>
                <Cell fill="#0088FE" /><Cell fill="#FF8042" />
              </Pie>
              <Tooltip contentStyle={TOOLTIP_STYLE} formatter={(v) => [v, "unidades"]} />
            </PieChart>
          </ResponsiveContainer>
          <p className="text-xs text-muted-foreground mt-1">{total} itens com personalização</p>
        </>
      ) : <p className="text-sm text-muted-foreground">Sem dados</p>}
    </div>
  );
}

// Corrigido em 21/09/2026 (autorizado pelo dono): bebida e sobremesa contam
// também quando vêm DENTRO do combo, açaí e dose são reconhecidos e o texto diz
// "dos pedidos" — a conta sempre foi por pedido, não por cliente.
export default function InsightsCombos({ analise }) {
  if (!analise?.total_pedidos) return null;
  const a = analise;
  return (
    <div className="bg-card rounded-xl border p-6" data-e2e="insights-combos">
      <div className="flex items-center gap-2 mb-1">
        <TrendingUp className="w-5 h-5 text-primary" />
        <h2 className="text-xl font-bold">Insights de Combos</h2>
        <span className="text-sm text-muted-foreground ml-auto">{a.total_pedidos} pedidos analisados</span>
      </div>
      <p className="text-xs text-muted-foreground mb-4">Bebida e sobremesa contam também quando vêm dentro do combo.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <ComboVsSimples simples={a.sanduiches_simples} combo={a.sanduiches_combo} />
        <Percentual titulo="Adicionais" pedidos={a.pedidos_com_adicional} total={a.total_pedidos}
          texto="dos pedidos incluem adicionais" corTexto="text-primary" corBarra="bg-violet-500" />
        <Percentual titulo="Bebidas" pedidos={a.pedidos_com_bebida} total={a.total_pedidos}
          texto="dos pedidos incluem bebidas" corTexto="text-cyan-600 dark:text-cyan-400" corBarra="bg-cyan-500" />
        <Percentual titulo="Sobremesas" pedidos={a.pedidos_com_sobremesa} total={a.total_pedidos}
          texto="dos pedidos incluem sobremesas" corTexto="text-orange-600 dark:text-orange-400" corBarra="bg-orange-500" />
      </div>
    </div>
  );
}
